import MixinScroll from '../mixin-scroll'
import { getPage } from '../../content.js'
import Shopify from '../utils/Shopify'

const shopify = new Shopify()

export default
{
    mixins: [
        MixinScroll
    ],

    props:
    {
        currentPage: { type: String }
    },

    data()
    {
        return {
            mainPages: [
                getPage('products'),
                getPage('eating')
            ],
            homePage: getPage('home'),
            secondPages: [
                getPage('story'),
                getPage('mission')
            ],
            isOnTop: true,
            cartCount: 0
        }
    },

    created()
    {
        shopify.getCart(this.onCartUpdated)
        shopify.onCartUpdated.add(this.onCartUpdated)
    },

    mounted()
    {
        // shopify.getItems(products => console.log('app-header products', products))
    },

    destroyed()
    {
        shopify.onCartUpdated.remove(this.onCartUpdated)
    },

    methods:
    {
        toggleMenu()
        {
            this.eventHub.$emit('menu:toggle')
        },

        onScroll(y)
        {
            this.isOnTop = y < 500
        },

        onCartUpdated(cart)
        {
            this.cartCount = cart.list.reduce((total, { quantity }) => total + quantity, 0)
        },

        openCart()
        {
            this.eventHub.$emit('cart:open')
        }
    }
}